import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import styled from 'styled-components';
import bankIcon from '../assets/images/bank_icon.png';
import Modal from '../components/Modals';
import month from '../constant/month.json';
import classes from './Basic.module.css';
import EditorialContent from './EditorialContent';
import Footer from './Footer';
import Header from './Header/Header';
import SavingsAccounts from './Savings/SavingsAccounts';

function Basic({listContent, showSavings}) {
    const advertising_disclosure_ref = React.useRef(null);
    const rate_disclosure_ref = React.useRef(null);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    const handleOpenAdvertisingClosureModal = () => {
        advertising_disclosure_ref.current.handleOpen();
    };

    const handleCloseAdvertisingClosureModal = () => {
        advertising_disclosure_ref.current.handleClose();
    };

    const handleLearnMoreOpen = () => {
        rate_disclosure_ref.current.handleOpen();
    };

    const handleLearnMoreClose = () => {
        rate_disclosure_ref.current.handleClose();
    };

    return (
        <AppWrapper>
            <Modal ref={advertising_disclosure_ref} is_default_false>
                <AdvertisingDisclosureModalWrapper>
                    <AdvertisingDisclosureCloseIconContainer>
                        <AdvertisingDisclosureCloseIcon>
                            <CloseIcon
                                sx={{color: '#fff'}}
                                onClick={handleCloseAdvertisingClosureModal}
                            />
                        </AdvertisingDisclosureCloseIcon>
                    </AdvertisingDisclosureCloseIconContainer>
                    <AdvertisingDisclosureHeaderContainer>
                        <AdvertisingDisclosureHeaderText>
                            PARTNER AND ADVERTISER DISCLOSURE
                        </AdvertisingDisclosureHeaderText>
                    </AdvertisingDisclosureHeaderContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            RATEZIP.COM is a comparison shopping website.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            We help consumers by collecting all of what we
                            consider to be the best deals on mortgage and other
                            products and enable consumers to comparison shop in
                            one place. Most of these deals are offered by
                            companies who will pay us a referral fee when
                            someone purchases their products or calls their
                            phone number. This is how we earn money. We don't
                            care which advertiser or partner you chose, but
                            benefit if you chose one of the partners listed on
                            our site.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            Reviews found on our Comparison Page are editorial
                            reviews. These reviews and ratings are not generated
                            by customers, but are written by RateZip employees
                            after the company is thoroughly researched. Some of
                            the companies reviewed are advertiser or partners.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            The prominence and order of the advertisers and
                            partners listed on the site may be affected by the
                            amount of money that the advertiser pays us. Thus
                            certain advertisements may gain prominence because
                            that advertiser is paying to promote their product.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            All of the lenders that advertise on RateZip.com
                            have been vetted by our editorial staff and we
                            believe are trustworthy and reputable companies to
                            do business with. There are thousands of home
                            lenders that we could list, and we are able to chose
                            what we think are the best.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            If you have any concerns, think there is a fantastic
                            lender that we should feature, or wish to give
                            feedback on the partners we have chosen, please
                            contact us! We'd love to hear from you.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                        <React.Fragment>
                            <AdvertisingDisclosureHeaderContainer>
                                <AdvertisingDisclosureHeaderText>
                                    Bankrate Advertiser Disclosure
                                </AdvertisingDisclosureHeaderText>
                            </AdvertisingDisclosureHeaderContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    We are an independent, advertising-supported
                                    comparison service. Our goal is to help you
                                    make smarter financial decisions by
                                    providing you with interactive tools and
                                    financial calculators, publishing original
                                    and objective content, by enabling you to
                                    conduct research and compare information for
                                    free - so that you can make financial
                                    decisions with confidence.
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                            <AdvertisingDisclosureHeaderContainer>
                                <AdvertisingDisclosureHeaderText h5>
                                    How We Make Money
                                </AdvertisingDisclosureHeaderText>
                            </AdvertisingDisclosureHeaderContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    The offers that appear on this site are from
                                    companies that compensate us. This
                                    compensation may impact how and where
                                    products appear on this site, including, for
                                    example, the order in which they may appear
                                    within the listing categories. But this
                                    compensation does not influence the
                                    information we publish, or the reviews that
                                    you see on this site. We do not include the
                                    universe of companies or financial offers
                                    that may be available to you.
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                            <AdvertisingDisclosureHeaderContainer>
                                <AdvertisingDisclosureHeaderText h5>
                                    Rates
                                </AdvertisingDisclosureHeaderText>
                            </AdvertisingDisclosureHeaderContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    The rate information is obtained by Bankrate
                                    from the listed institutions. Bankrate
                                    cannot guarantee the accuracy or
                                    availability of any rates shown.
                                    Institutions may have different rates on
                                    their own websites than those posted on
                                    Bankrate.com. The listings that appear on
                                    this page are from companies from which this
                                    website receives compensation, which may
                                    impact how, where, and in what order
                                    products appear. This table does not include
                                    all companies or all available products.
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    All rates are subject to change without
                                    notice and may vary depending on location.
                                    These quotes are from banks, thrifts, and
                                    credit unions, some of whom have paid for a
                                    link to their own website where you can find
                                    additional information. Those with a paid
                                    link are our Advertisers. Those without a
                                    paid link are listings we obtain to improve
                                    the consumer shopping experience and are not
                                    Advertisers. To receive the Bankrate.com
                                    rate from an Advertiser, please identify
                                    yourself as a Bankrate customer. Bank and
                                    thrift deposits are insured by the Federal
                                    Deposit Insurance Corp. Credit union
                                    deposits are insured by the National Credit
                                    Union Administration.
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    Consumer Satisfaction: Bankrate attempts to
                                    verify the accuracy and availability of its
                                    Advertisers' terms through its quality
                                    assurance process and requires Advertisers
                                    to agree to our Terms and Conditions and to
                                    adhere to our Quality Control Program. If
                                    you believe that you have received an
                                    inaccurate quote or are otherwise not
                                    satisfied with the services provided to you
                                    by the institution you choose, please{' '}
                                    <a href='https://www.bankrate.com/contact/'>
                                        click here
                                    </a>
                                    .
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                            <AdvertisingDisclosureContentContainer>
                                <AdvertisingDisclosureContentText>
                                    Rate collection and criteria:{' '}
                                    <a href='https://www.bankrate.com/investing/product-criteria/?prodtype=invest'>
                                        Click here
                                    </a>{' '}
                                    for more information on rate collection and
                                    criteria.
                                </AdvertisingDisclosureContentText>
                            </AdvertisingDisclosureContentContainer>
                        </React.Fragment>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            Sincerely, <br />
                            RateZip.com
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureCloseButtonContainer>
                        <AdvertisingDisclosureCloseButton
                            onClick={handleCloseAdvertisingClosureModal}
                        >
                            Close
                        </AdvertisingDisclosureCloseButton>
                    </AdvertisingDisclosureCloseButtonContainer>
                </AdvertisingDisclosureModalWrapper>
            </Modal>
            <Modal ref={rate_disclosure_ref} is_default_false>
                <AdvertisingDisclosureModalWrapper>
                    <AdvertisingDisclosureCloseIconContainer>
                        <AdvertisingDisclosureCloseIcon>
                            <CloseIcon
                                sx={{color: '#fff'}}
                                onClick={handleLearnMoreClose}
                            />
                        </AdvertisingDisclosureCloseIcon>
                    </AdvertisingDisclosureCloseIconContainer>
                    <AdvertisingDisclosureHeaderContainer>
                        <AdvertisingDisclosureHeaderText>
                            About Our Sponsored Offers
                        </AdvertisingDisclosureHeaderText>
                    </AdvertisingDisclosureHeaderContainer>
                    <AdvertisingDisclosureContentContainer>
                        <AdvertisingDisclosureContentText>
                            Our list of sponsored accounts offer competitive
                            rates, multiple times higher than the national
                            average. All of these offers have FDIC or NCUA
                            insurance, have competitive minimums and few fees.
                            We've vetted the credit worthiness of these banks to
                            simplify your search.
                        </AdvertisingDisclosureContentText>
                    </AdvertisingDisclosureContentContainer>
                    <AdvertisingDisclosureCloseButtonContainer>
                        <AdvertisingDisclosureCloseButton
                            onClick={handleLearnMoreClose}
                        >
                            Close
                        </AdvertisingDisclosureCloseButton>
                    </AdvertisingDisclosureCloseButtonContainer>
                </AdvertisingDisclosureModalWrapper>
            </Modal>
            <Header handleOpen={handleOpenAdvertisingClosureModal} />
            <ContentContainer>
                <div className={classes.headerText}>
                    <h2>
                        Great{' '}
                        <span style={{color: '#2da83e!important'}}>
                            CD Rates
                        </span>{' '}
                        from Our Partners for {month[currentMonth]}{' '}
                        {currentYear}
                    </h2>
                </div>
                <div className={classes.subheaderText}>
                    <img loading='lazy' src={bankIcon} alt='bank icon' />
                    <h4>Compare the Top Certificate of Deposit Accounts</h4>
                </div>
                <div className={classes.subheaderText}>
                    <img loading='lazy' src={bankIcon} alt='bank icon' />
                    <h4>Open a New Account in Minutes</h4>
                </div>
                <div className={classes.featured}>
                    <h2>Sponsored offers</h2>
                    <Tooltip
                        title={
                            'Offers featured here have been sponsored, which impacts how, where, and in what order the products appear. Not all offers are displayed on this page.'
                        }
                    >
                        <InfoOutlinedIcon fontSize='small' color='primary' />
                    </Tooltip>
                </div>
                <p>
                    These are sponsored offers rated highly by us for
                    competitive rates, fees, and minimums.{' '}
                    <span
                        onClick={handleLearnMoreOpen}
                        className={classes.learnMore}
                    >
                        Learn More.
                    </span>
                </p>
                <ResultListContainer>
                    {listContent.length === 0 ? (
                        <p>No Match Data</p>
                    ) : (
                        listContent
                    )}
                </ResultListContainer>
                <PowerByContainer>
                    <PowerByText>Powered by:</PowerByText>
                    <PowerByLink href='https://www.bankrate.com/'>
                        <PowerByImage
                            src={'https://www.ratezip.com/images/Bankrate.png'}
                            alt={'Bankrate Logo'}
                        />
                    </PowerByLink>
                    <PrivacyPolicyLink href='https://www.bankrate.com/privacy/'>
                        Privacy Policy
                    </PrivacyPolicyLink>
                </PowerByContainer>
                { showSavings && <SavingsAccounts /> }
                <EditorialContent />
            </ContentContainer>
            <Footer />
        </AppWrapper>
    );
}

const AppWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @media (max-width: 515px) {
        width: 100vw;
    }
`;

const ContentContainer = styled.div`
    max-width: 1036px;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const ResultListContainer = styled.div`
    width: 100%;

    > p {
        padding: 20px 0px;
        text-align: center;
    }
`;

const AdvertisingDisclosureModalWrapper = styled.div`
    width: 35%;
    background-color: #fff;
    z-index: 2000;
    position: absolute;
    top: 10px;
    left: 32.5%;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    padding: 1rem;
    overflow-y: scroll;
    max-height: 90vh;

    @media (max-width: 515px) {
        width: 87%;
        left: 2%;
    }
`;

const AdvertisingDisclosureCloseIconContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

const AdvertisingDisclosureCloseIcon = styled.div`
    background-color: #3e77ac;
    width: 35px;
    height: 35px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const AdvertisingDisclosureHeaderContainer = styled.div`
    padding: 0.5rem 0px;
`;

const AdvertisingDisclosureHeaderText = styled.h5`
    font-weight: 500;
    margin: 0px;
    font-size: ${(p) => (p.h5 ? '1.15rem' : '1.25rem')};
`;

const AdvertisingDisclosureContentContainer = styled.div`
    padding: 0.5rem 0px;
`;

const AdvertisingDisclosureContentText = styled.p`
    font-size: 0.8em;
    margin: 0px;
`;

const AdvertisingDisclosureCloseButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const AdvertisingDisclosureCloseButton = styled(Button)`
    background-color: #3e77ac;
    border: none;
    color: #fff;
    width: 75px;
    height: 36px;
    text-transform: capitalize;
    font-weight: 600 !important;
`;

const PowerByContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 0px;
`;

const PowerByText = styled.p`
    font-size: 10px;
    margin-bottom: 0px;
`;

const PowerByLink = styled.a``;

const PrivacyPolicyLink = styled.a`
    margin-top: 4px;
    font-size: 10px;
`;

const PowerByImage = styled.img`
    height: 15px;
    transform: translateY(5px);
`;

export default Basic;
